import React, { useEffect, useMemo, useRef, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';

interface Props {
  onCreateSession: () => void;
  telasPermitidas: string[] | null;
  isAdmin: boolean;
  mobileOpen?: boolean;
  onCloseMobile?: () => void;
  userName?: string;
  userType?: string;
  onLogout?: () => void;
  temMaturador?: boolean;
}

type NavItem = {
  to: string;
  end: boolean;
  label: string;
  adminOnly: boolean;
  operatorOnly?: boolean;
  icon: React.ReactNode;
};

const NAV_ITEMS: NavItem[] = [
  {
    to: '/',
    end: true,
    label: 'Conectar WhatsApp',
    adminOnly: false,
    icon: (
      <g transform="translate(2 2) scale(0.045)">
        <path
          fill="currentColor"
          stroke="none"
          d="M380.9 97.1C339 55.1 283.2 32 223.9 32 101.5 32 2.2 131.3 2.2 253.7c0 39.1 10.2 77.3 29.6 111L0 480l118.7-31.1c32.6 17.8 69.3 27.2 107.4 27.2h.1c122.3 0 223.9-99.3 223.9-221.7 0-59.3-23.1-115-65.2-157.3zM223.9 438.7c-33.8 0-67-8.6-96.3-24.8l-6.9-4.1-70.5 18.5 18.8-68.7-4.5-7.2c-18.7-29.7-28.6-64-28.6-99.2 0-103.3 84.1-187.5 187.6-187.5 50.1 0 97.2 19.5 132.6 55 35.4 35.4 54.9 82.5 54.9 132.7-.1 103.3-84.2 187.3-187.1 187.3zm101.3-138.4c-5.5-2.8-32.8-16.1-37.9-17.9-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.5-14.3 17.9-17.6 21.6-3.2 3.7-6.5 4.2-12 .9-32.6-16.3-54-29.1-75.7-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.3-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.5-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.7 35.1 15.2 48.8 16.5 66.3 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.3-5-3.7-10.6-6.5z"
        />
      </g>
    ),
  },
  { to: '/disparador', end: false, label: 'Disparar Mensagens', adminOnly: false,
    icon: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" /> },
  { to: '/relatorio-respostas', end: false, label: 'Respostas por Usuário', adminOnly: true,
    icon: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" /> },
  { to: '/respostas', end: false, label: 'Respostas', adminOnly: false,
    icon: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" /> },
  { to: '/templates', end: false, label: 'Modelos de Mensagens', adminOnly: false,
    icon: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V19a2 2 0 01-2 2zM13 3v4a1 1 0 001 1h4" /> },
  { to: '/maturacao', end: false, label: 'Maturador de Chip', adminOnly: false,
    icon: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M13 10V3L4 14h7v7l9-11h-7z" /> },
  { to: '/minha-assinatura', end: false, label: 'Minha Assinatura', adminOnly: false, operatorOnly: true,
    icon: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" /> },
  { to: '/usuarios', end: false, label: 'Usuários', adminOnly: true,
    icon: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" /> },
  { to: '/assinantes', end: false, label: 'Assinantes', adminOnly: true,
    icon: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" /> },
  { to: '/config-teste', end: false, label: 'Teste Gratuito', adminOnly: true,
    icon: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /> },
  { to: '/planos', end: false, label: 'Planos', adminOnly: true,
    icon: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" /> },
  { to: '/webhook-admin', end: false, label: 'Pagamentos', adminOnly: true,
    icon: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.8} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" /> },
];

export default function Sidebar({ telasPermitidas, isAdmin, mobileOpen = false, onCloseMobile, userName, userType, onLogout, temMaturador }: Props) {
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const userMenuRef = useRef<HTMLDivElement>(null);
  const [search, setSearch] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (userMenuRef.current && !userMenuRef.current.contains(e.target as Node)) {
        setUserMenuOpen(false);
      }
    };
    if (userMenuOpen) document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [userMenuOpen]);

  const visibleItems = useMemo(() => NAV_ITEMS.filter((item) => {
    if (item.to === '/maturacao') return !!temMaturador;
    if (item.adminOnly) return isAdmin;
    if (item.operatorOnly) return !isAdmin;
    // "Quem Respondeu" sempre visível para todos os usuários logados.
    if (item.to === '/respostas') return true;
    return telasPermitidas === null || telasPermitidas.includes(item.to);
  }), [isAdmin, telasPermitidas, temMaturador]);

  const filtroNormalizado = search.trim().toLowerCase();
  const itensFiltrados = filtroNormalizado
    ? visibleItems.filter((i) => i.label.toLowerCase().includes(filtroNormalizado))
    : visibleItems;

  const handleSearchKey = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && itensFiltrados.length > 0) {
      navigate(itensFiltrados[0].to);
      setSearch('');
      onCloseMobile?.();
    } else if (e.key === 'Escape') {
      setSearch('');
    }
  };

  const firstName = userName?.split(' ')[0] || 'Usuário';
  const initials = userName?.split(' ').slice(0, 2).map(p => p[0]?.toUpperCase()).join('') || 'U';

  return (
    <>
      {mobileOpen && (
        <button
          type="button"
          aria-label="Fechar menu"
          className="fixed inset-0 z-30 bg-black/40 md:hidden"
          onClick={onCloseMobile}
        />
      )}
      <aside
        className={`fixed inset-y-0 left-0 z-40 h-screen w-[240px] transform flex flex-col justify-between transition-transform duration-300 md:static md:z-auto md:translate-x-0 ${mobileOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'}`}
        style={{ background: '#191919' }}
      >
        {/* Topo */}
        <div className="flex flex-col gap-1">
          {/* Branding + botão fechar (mobile) */}
          <div className="relative flex items-center justify-center h-16 px-4 border-b border-white/5 flex-shrink-0">
            <span className="text-xl font-bold text-white tracking-tight whitespace-nowrap">
              Disparador Pro
            </span>
            <button
              type="button"
              onClick={onCloseMobile}
              className="md:hidden absolute right-3 w-8 h-8 flex items-center justify-center rounded-btn text-white/70 hover:text-white"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          {/* Busca de tela */}
          <div className="px-3 pt-3">
            <div className="relative">
              <span className="absolute left-3 top-1/2 -translate-y-1/2 text-white/40 pointer-events-none">
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-4.35-4.35M11 19a8 8 0 100-16 8 8 0 000 16z" />
                </svg>
              </span>
              <input
                type="text"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                onKeyDown={handleSearchKey}
                placeholder="Buscar tela..."
                className="w-full h-9 pl-9 pr-8 rounded-lg text-sm text-white placeholder:text-white/40 bg-white/10 border border-white/10 focus:outline-none focus:border-white/30 focus:bg-white/15 transition-colors"
              />
              {search && (
                <button
                  type="button"
                  onClick={() => setSearch('')}
                  className="absolute right-2 top-1/2 -translate-y-1/2 w-5 h-5 rounded-full flex items-center justify-center text-white/50 hover:text-white hover:bg-white/10"
                  aria-label="Limpar busca"
                >
                  <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              )}
            </div>
          </div>

          {/* Navegação */}
          <nav className="flex flex-col gap-0.5 px-3 pt-3">
            {itensFiltrados.length === 0 && (
              <p className="text-xs text-white/50 px-3 py-2">Nenhuma tela encontrada</p>
            )}
            {itensFiltrados.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                onClick={() => onCloseMobile?.()}
                className={({ isActive }) =>
                  `flex items-center gap-3 w-full px-3 py-2.5 rounded-lg text-sm font-medium transition-colors duration-150 ${
                    isActive ? 'bg-white/15 text-white' : 'text-white/80 hover:bg-white/10 hover:text-white'
                  }`
                }
              >
                <svg
                  className="w-5 h-5 flex-shrink-0"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  {item.icon}
                </svg>
                <span className="whitespace-nowrap truncate">{item.label}</span>
              </NavLink>
            ))}
          </nav>
        </div>

        {/* Rodapé */}
        <div className="flex flex-col gap-3 px-3 pb-4">
          {/* User card com dropdown */}
          <div className="relative" ref={userMenuRef}>
            {userMenuOpen && (
              <div className="absolute bottom-full left-0 right-0 mb-2 bg-white border border-line rounded-btn shadow-lg overflow-hidden z-50">
                <button
                  type="button"
                  onClick={() => { setUserMenuOpen(false); onLogout?.(); }}
                  className="w-full flex items-center gap-2.5 px-4 py-3 text-sm text-red-500 hover:bg-red-50 transition-colors"
                >
                  <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                  </svg>
                  Sair do sistema
                </button>
              </div>
            )}

            <button
              type="button"
              onClick={() => setUserMenuOpen(v => !v)}
              className="outline-none flex items-center justify-between gap-2 rounded-lg py-2 px-3 cursor-pointer w-full text-left hover:bg-white/10 transition-all"
            >
              <div className="flex items-center gap-2.5 min-w-0">
                <div
                  className="w-8 h-8 rounded-full flex-shrink-0 flex items-center justify-center text-xs font-bold"
                  style={{ background: '#9EEA6C', color: '#244C4E' }}
                >
                  {initials}
                </div>
                <div className="flex flex-col gap-0.5 min-w-0">
                  <span className="text-sm font-semibold text-white truncate">{firstName}</span>
                  <span className="text-[11px] text-white/60 capitalize truncate">{userType || 'usuário'}</span>
                </div>
              </div>
              <svg
                className={`w-4 h-4 text-white/60 flex-shrink-0 transition-transform ${userMenuOpen ? 'rotate-180' : ''}`}
                fill="none" stroke="currentColor" viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
              </svg>
            </button>
          </div>

          {/* Rootfy Code */}
          <div className="px-1 text-center">
            <p className="text-[11px] text-white/40 leading-tight">
              desenvolvido por{' '}
              <a
                href="https://rootfycode.com.br"
                target="_blank"
                rel="noopener noreferrer"
                className="font-semibold text-white/60 hover:text-white transition-colors"
              >
                Rootfy Code
              </a>
            </p>
          </div>
        </div>
      </aside>
    </>
  );
}
